module.exports = __webpack_public_path__ + "img/result-04.d32e6d59.jpg";